import React, { memo, useEffect, useState } from 'react';
import { useWindowDimensions} from 'react-native';

import ImageCanvas from '../../canvas/imageCanvas/ImageCanvas';
import { webViewCanvasCommands } from '../webViewCanvasUtils';
import env from '../../../constants/env';

const isLandscape = false;

const WebViewImageCanvas = () => {
	const layout = useWindowDimensions();

	const [data, setData] = useState({});
	const [isLoading, setIsLoading] = useState(true);

	const onClose = () => {
		const message = JSON.stringify({
			type: webViewCanvasCommands.close,
		});
		if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(message);
	};

	const save = async (data) => {
		const message = JSON.stringify({
			type: webViewCanvasCommands.save,
			data,
		});
		if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(message);
	};

	useEffect(() => {
		try {
			const imageDiv = document.getElementById('imageDiv');
			const sketchDiv = document.getElementById('sketchDiv');
			const localImage = {
				image: imageDiv ? imageDiv.innerText : undefined,
				sketch: sketchDiv ? sketchDiv.innerText : undefined,
			};

			setData(localImage);
			setTimeout(() => {
				if (imageDiv) imageDiv.remove();
				if (sketchDiv) sketchDiv.remove();
				const message = JSON.stringify({ type: webViewCanvasCommands.loaded });
				if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(message);
				setIsLoading(false);
			}, 100);
		}
		catch (err) {
			if (env.NODE_ENV === 'local') window.alert(err);
			else window.alert('Error Loading Canvas');
		}
	}, []);

	return (
		<>
			{!isLoading && <ImageCanvas
				onClose={onClose}
				containerDims={layout}
				image={data.image}
				sketch={data.sketch}
				save={save}
				isLandscape={isLandscape}
			/>}
		</>
	);
};

export default memo(WebViewImageCanvas);